var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionFolderPin({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 13h-1v2l1 2v2h-3v3l-1 1-1-1v-3h-3v-2l1-2v-2h-1v-2h8v2ZM12 6h8a2 2 0 0 1 2 2v1H12v11H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h6l2 2Zm5 9.472-.21.423L16.235 17h3.528l-.553-1.105-.211-.423V13h-2v2.472Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M22 13h-1v2l1 2v2h-3v3l-1 1-1-1v-3h-3v-2l1-2v-2h-1v-2h8v2Zm-5 2.472L16.236 17h3.528L19 15.472V13h-2v2.472Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6h8a2 2 0 0 1 2 2v1H12v11H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h6l2 2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionFolderPin);
export default __webpack_public_path__ + "static/media/ic_action_folder_pin.7a9ddcbc658dc5ae22d64ffde7619d4b.svg";
export { ForwardRef as ReactComponent };